import SignupPage from '@/pages/auth/signup/SignupPage'
import LoginPage from '@/pages/auth/login/LoginPage'
import OAuthPage from '@/pages/auth/oauth/OAuthPage'
import OtpPage from '@/pages/auth/otp/OtpPage'
import ForgotPasswordPage from '@/pages/auth/forgot-password/ForgotPasswordPage'

export default [
    {
        path: '/login',
        name: 'LoginPage',
        component: LoginPage,
        meta: {
            title: 'Findus | Digital Archive - Login'
        }
    },
    {
        path: '/sign-up',
        name: 'SignupPage',
        component: SignupPage,
        meta: {
            title: 'Findus | Digital Archive - Signup'
        }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPasswordPage',
        component: ForgotPasswordPage,
        meta: {
            title: 'Findus | Digital Archive - Forgot Password'
        }
    },
    {
        path: '/oauth',
        name: 'OAuthPage',
        component: OAuthPage,
        meta: {
            title: 'Findus | Digital Archive - OAuth'
        }
    },
    {
        path: '/verify-otp',
        name: 'OtpPage',
        component: OtpPage,
        meta: {
            title: 'Findus | Digital Archive - Verify OTP'
        }
    },

    /** Redirect to Home */
    {
        path: '*',
        redirect: '/'
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/auth.js